import { observer } from "mobx-react";

import "./ProjectsActiveReportTaskBoostInfo.scss";

const ProjectsActiveReportTaskBoostInfo = observer(({ report }) => {
  const { extraPrice = 0, extraPriceNext } = report;
  
  if (extraPrice <= 0 && !extraPriceNext) return null;

  return (
    <div className="task-boost-info">
      <div className="task-boost-info__current">
        Ставка <b>+ {extraPrice || extraPriceNext} ₽</b>
      </div>
    </div>
  );
});

export default ProjectsActiveReportTaskBoostInfo;